import axios from "axios";
import router from "../router";

export const Actions = {
  // getUserInfo({ commit }) {
  //   axios
  //     .get("/")
  //     .then(response => {
  //       if (response.data.status == 200) {
  //         commit("userInfoSuccess", response.data.data.userinfo);
  //       } else {
  //         //location.reload("/login");
  //         console.log("server error: " + response.data.status);
  //       }
  //     })
  //     .catch(err => {
  //       console.log(err);
  //     });
  // },
  // getPopularPoster({ commit }, payload) {
  //   axios
  //     .get(
  //       "http://ssgsag-alb-2141317761.ap-northeast-2.elb.amazonaws.com/poster/web/api?sortType=0&curPage=0&category=" +
  //         payload.category
  //     )
  //     .then(response => {
  //       console.log(response);
  //       if (response.data.status === 200) {
  //         let posterList = response.data.data.summaryPosterList;
  //         let total = response.data.data.total;
  //         for (var i = 0; i < posterList.length; i++) {
  //           posterList[i].posterEndDate = posterList[i].posterEndDate.substring(
  //             0,
  //             10
  //           );
  //         }
  //         commit("popularPosterSuccess", {
  //           posterList: posterList,
  //           total: total
  //         });
  //       } else {
  //         location.reload("/login");
  //         console.log("server error: " + response.data.status);
  //       }
  //     })
  //     .catch(err => {
  //       console.log(err);
  //     });
  // },
  postLogin({ commit }, payload) {
    axios
      .post(
        "/api/users/login", payload
      )
      .then(response => {
        console.log(response);
        if (response.data.status == 200) {
          commit("loginSuccess", {
            userinfo: response.data.data
          });
        } else {
          commit('loginFail')
          console.log("server error: " + response.data);
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  postLogout({ commit }) {
    axios
      .post(
        "/api/users/logout"
      )
      .then(response => {
        console.log(response);
        if (response.data.status == 200) {
          commit("logoutSuccess");
        } else {
          console.log("server error: " + response.data);
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  postSignUp({ commit }, payload) {
    axios
      .post(
        "/api/users", payload
      )
      .then(response => {
        console.log(response);
        if (response.data.status == 200) {
          console.log('response.data: ' + response.data);
          commit("signUpResult", 0);
        } else {
          commit("signUpResult", 1);
          console.log("server error: " + response.data);
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  goLogin({commit}){
    commit("goLoginSuccess");
  },
  setErrMsg({commit}, payload){
    commit('setErrMsg', payload);
  },
  clearErrMsg({commit}){
    commit('clearErrMsg');
  }
};



// WEBPACK FOOTER //
// ./src/store/actions.js